/*
----------------------------
Module - pagination
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

//--------------------
// Events Pagination
//--------------------
(function(){
    'use strict';

    // Events Pagination
    fmg.eventsPagination = function() {

        // Just extract GET params and AJAX in content in events results container
        function getEventsPaginatedResults($pagination_link_anchor) {

            // Extract the query string
            var pagination_link_href = $pagination_link_anchor.prop("href");

            var pagination_link_params = pagination_link_href.split("?")[1];

            // Concatenate query string with base search endpoint URL which includes ?collection=...&amp;
            var new_requested_search_endpoint = base_search_endpoint + "&" + pagination_link_params;

            // Ajax results from endpoint and insert into container
            $event_results_inner.load(new_requested_search_endpoint, function() {

                // Scroll back to top of results listing
                $("html,body").animate({
                    scrollTop: $event_results_inner.offset().top - 120
                });

                // Update URL without reload so that users can press back to last pagination view
                window.history.replaceState("", "", "?" + pagination_link_params);

            });

        }

        function setupEventsPagination() {

            $("body").on("click", ".event-results__pagination a.pagination__link", function(event) {

                event.preventDefault();

                var $pagination_link_anchor = $(event.target);

                getEventsPaginatedResults($pagination_link_anchor);

            });

        }

        function init() {

            $event_results_wrapper = $(".events-results");
           
            if ($event_results_wrapper.length) {

                $event_results_inner = $event_results_wrapper.find(".events-results__inner")
                base_search_endpoint = $event_results_wrapper.data("search-endpoint");

                if ($event_results_inner.length && base_search_endpoint.length) {
                    
                    // Binding click event on anchor tags
                    setupEventsPagination();

                }

            }

        }
        
        return {
            init: init
        };

    }();

    var $event_results_wrapper;
    var $event_results_inner;
    var base_search_endpoint;

    document.addEventListener("DOMContentLoaded", function () {
        fmg.eventsPagination.init();
    });
    
}());

//--------------------
// News Pagination
//--------------------
(function(){
    'use strict';

    fmg.newsPagination = function() {

        // Just extract GET params and AJAX in content in news results container
        function getNewsPaginatedResults($pagination_link_anchor) {

            // Extract the query string
            var pagination_link_href = $pagination_link_anchor.prop("href");

            var pagination_link_params = pagination_link_href.split("?")[1];

            // Concatenate query string with base search endpoint URL which includes ?collection=...&amp;
            var new_requested_search_endpoint = base_search_endpoint + "&" + pagination_link_params;

            // Ajax results from endpoint and insert into container
            $.get( new_requested_search_endpoint, function( data ) {

                // Results summary
                var $new_results_summary = $(data).find(news_results_summary_wrapper_class);

                if ($new_results_summary.length) {
                    $news_results_summary_wrapper.html($new_results_summary.html());
                }

                // First part results
                var $new_first_part_results = $(data).find(news_first_part_results_wrapper_class);

                if ($new_first_part_results.length) {
                    $news_first_part_results_wrapper.html($new_first_part_results.html());
                }
                
                // Leftover main results
                var $new_results_listing = $(data).find(news_results_listing_wrapper_class);

                if ($new_results_listing.length) {
                    $news_results_listing_wrapper.html($new_results_listing.html());
                }

                // Pagination
                var $new_pagination = $(data).find(news_pagination_wrapper_class);

                if ($new_pagination.length) {
                    $news_pagination_wrapper.html($new_pagination.html());
                }

                // Scroll back to top of results listing
                $("html,body").animate({
                    scrollTop: $news_results_inner.offset().top - 120
                });

                 // Update URL without reload so that users can press back to last filtered view
                 window.history.replaceState("", "", "?" + pagination_link_params);
                
            });

        }

        function setupNewsPagination() {

            $("body").on("click", ".news-results__pagination a.pagination__link", function(event) {

                event.preventDefault();

                var $pagination_link_anchor = $(event.target);

                getNewsPaginatedResults($pagination_link_anchor);

            });

        }

        function init() {

            $news_results_wrapper = $(".news-results");
           
            if ($news_results_wrapper.length) {

                $news_results_inner = $news_results_wrapper.find(".news-results__inner")
                base_search_endpoint = $news_results_wrapper.data("search-endpoint");

                $news_results_summary_wrapper = $(news_results_summary_wrapper_class);
                $news_first_part_results_wrapper = $(news_first_part_results_wrapper_class);
                $news_results_listing_wrapper = $(news_results_listing_wrapper_class);
                $news_pagination_wrapper = $(news_pagination_wrapper_class);

                if ($news_results_inner.length && base_search_endpoint.length) {
                    
                    // Binding click event on anchor tags
                    setupNewsPagination();

                }

            }

        }
        
        return {
            init: init
        };

    }();

    var $news_results_wrapper;
    var $news_results_inner;
    var base_search_endpoint;

    var $news_results_summary_wrapper;
    var news_results_summary_wrapper_class = ".news-results__summary";
    var $news_first_part_results_wrapper;
    var news_first_part_results_wrapper_class = ".news-results__listing-first-part";
    var $news_results_listing_wrapper;
    var news_results_listing_wrapper_class = ".news-results__listing-wrapper";
    var $news_pagination_wrapper;
    var news_pagination_wrapper_class = ".news-results__pagination-wrapper";

    document.addEventListener("DOMContentLoaded", function () {
        fmg.newsPagination.init();
    });
    
}());

//--------------------------
// Global Search Pagination
//--------------------------

(function(){
    'use strict';

    fmg.searchPagination = function() {

        // Just extract GET params and AJAX in content in news results container
        function getSearchPaginatedResults($pagination_link_anchor) {

            // Extract the query string
            var pagination_link_href = $pagination_link_anchor.prop("href");

            var pagination_link_params = pagination_link_href.split("?")[1];

            // Concatenate query string with base search endpoint URL which includes ?collection=...&amp;
            var new_requested_search_endpoint = base_search_endpoint + "&" + pagination_link_params;

            // Ajax results from endpoint and insert into container
            $.get( new_requested_search_endpoint, function( data ) {

                // Unlike the other pagination components (e.g. news/events) where their pagination wrapper exists at all times even after filtering
                // Everytime a new global search is performed, the pagination wrapper in <main> is replaced by a new pagination wrapper
                // Have to make jQuery find the new wrapper element to insert new results into

                // Results summary
                var $new_results_summary = $(data).find(search_results_summary_wrapper_class);

                if ($new_results_summary.length) {
                    $(search_results_summary_wrapper_class).html($new_results_summary.html());
                }

                // Main results
                var $new_results_listing = $(data).find(search_results_listing_wrapper_class);

                if ($new_results_listing.length) {
                    $(search_results_listing_wrapper_class).html($new_results_listing.html());
                }

                // Pagination
                var $new_pagination = $(data).find(search_pagination_wrapper_class);

                if ($new_pagination.length) {
                    $(search_pagination_wrapper_class).html($new_pagination.html());
                }

                // Scroll back to top of results listing
                $("html,body").animate({
                    scrollTop: $search_results_inner.offset().top - 120
                });

                 // Update URL without reload so that users can press back to last filtered view
                 window.history.replaceState("", "", "?" + pagination_link_params);
                
            });

        }

        function setupSearchPagination() {

            $("body").on("click", ".search-results__pagination a.pagination__link", function(event) {

                event.preventDefault();

                var $pagination_link_anchor = $(event.target);

                getSearchPaginatedResults($pagination_link_anchor);

            });

        }

        function init() {

            $search_results_wrapper = $(".search-results");
           
            if ($search_results_wrapper.length) {

                $search_results_inner = $search_results_wrapper.find(".search-results__inner")
                base_search_endpoint = $search_results_wrapper.data("search-endpoint");

                if ($search_results_inner.length && base_search_endpoint.length) {
                    
                    // Binding click event on anchor tags
                    setupSearchPagination();

                }

            }

        }
        
        return {
            init: init
        };

    }();

    var $search_results_wrapper;
    var $search_results_inner;
    var base_search_endpoint;

    var search_results_summary_wrapper_class = ".search-results__summary";
    var search_results_listing_wrapper_class = ".search-results__listing-wrapper";
    var search_pagination_wrapper_class = ".search-results__pagination-wrapper";

    document.addEventListener("DOMContentLoaded", function () {
        fmg.searchPagination.init();
    });
    
}());